// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__R1vUQ","rotation":"Circle_rotation__mLKOo"};